import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function PatientDetailsTabsList() {
  const {t} = useTranslate('common')
  return (
    <Tabs.List>
      <Tabs.Trigger value="therapy">{t('therapy')}</Tabs.Trigger>
      <Tabs.Trigger value="gfr_lab">{t('gfr_lab')}</Tabs.Trigger>
      <Tabs.Trigger value="about">{t('about')}</Tabs.Trigger>
      <Tabs.Trigger value="history">{t('history')}</Tabs.Trigger>
    </Tabs.List>
  )
}
